'use strict';

var createMuiTheme$1 = require('../../../../_virtual/createMuiTheme.js_commonjs-exports.js');
var interopRequireDefault = require('../../../@babel/runtime/helpers/interopRequireDefault.js');
var defineProperty = require('../../../@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../@babel/runtime/helpers/objectWithoutProperties.js');
var index = require('../../../../_virtual/index.js_commonjs-proxy4.js');
require('./createBreakpoints.js');
require('./createMixins.js');
require('./createPalette.js');
require('./createTypography.js');
require('./shadows.js');
require('./shape.js');
require('./createSpacing.js');
require('./transitions.js');
require('./zIndex.js');
var createBreakpoints = require('../../../../_virtual/createBreakpoints.js_commonjs-exports.js');
var createMixins = require('../../../../_virtual/createMixins.js_commonjs-exports.js');
var createPalette = require('../../../../_virtual/createPalette.js_commonjs-exports.js');
var createTypography = require('../../../../_virtual/createTypography.js_commonjs-exports.js');
var shadows = require('../../../../_virtual/shadows.js_commonjs-exports.js');
var shape = require('../../../../_virtual/shape.js_commonjs-exports.js');
var createSpacing = require('../../../../_virtual/createSpacing.js_commonjs-exports.js');
var transitions = require('../../../../_virtual/transitions.js_commonjs-exports.js');
var zIndex = require('../../../../_virtual/zIndex.js_commonjs-exports.js');

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(createMuiTheme$1.__exports, "__esModule", {
  value: true
});
createMuiTheme$1.__exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(defineProperty);

var _objectWithoutProperties2 = _interopRequireDefault(objectWithoutProperties);

var _utils = index;

var _createBreakpoints = _interopRequireDefault(createBreakpoints.__exports);

var _createMixins = _interopRequireDefault(createMixins.__exports);

var _createPalette = _interopRequireDefault(createPalette.__exports);

var _createTypography = _interopRequireDefault(createTypography.__exports);

var _shadows = _interopRequireDefault(shadows.__exports);

var _shape = _interopRequireDefault(shape.__exports);

var _createSpacing = _interopRequireDefault(createSpacing.__exports);

var _transitions = _interopRequireDefault(transitions.__exports);

var _zIndex = _interopRequireDefault(zIndex.__exports);

function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);
  var palette = (0, _createPalette.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
  var spacing = (0, _createSpacing.default)(spacingInput);
  var muiTheme = (0, _utils.deepmerge)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: _shadows.default,
    typography: (0, _createTypography.default)(palette, typographyInput),
    spacing: spacing,
    shape: _shape.default,
    transitions: _transitions.default,
    zIndex: _zIndex.default
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return (0, _utils.deepmerge)(acc, argument);
  }, muiTheme);

  if (process.env.NODE_ENV !== 'production') {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: (0, _defineProperty2.default)({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

var _default = createMuiTheme;
createMuiTheme$1.__exports.default = _default;
